module.exports = __webpack_public_path__ + "static/beach2-5e8ae75ab1da7e1adef831a48af777aa.jpg";